module.exports = __webpack_public_path__ + "img/heping.80a61571.jpg";